import { Interceptors } from "../../shared/interceptors";
export const ConfigService = {
  getTabData() {
    // header:{'reqHeader':"test"},
    let URI = `${process.env.REACT_APP_UI_CONFIG_BASE}tabs`;
    return Interceptors.requestInterceptors('GET',URI);
  }
};
